import { Alert, Typography } from '@mui/material';
import { Flooding } from 'features/flooding/flooding.types';
import { HazardListItem } from 'features/hazards/hazard.types';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { deactivationWouldOrphanActiveHazards } from '../FloodingForm/FloodingForm.utils';
import { FloodingFormValues } from '../FloodingForm/FloodingForm.types';

type FloodingWarningsProps = {
  flooding: Flooding;
  hazards: HazardListItem[];
};

export const FloodingWarnings = (
  props: FloodingWarningsProps,
): JSX.Element | null => {
  const { flooding, hazards } = props;
  const { t } = useTranslation();

  const status = useWatch<FloodingFormValues>({ name: 'status' });

  const isDeactivating = flooding.isActive && status === 'inactive';

  const showOrphanWarning = useMemo(
    () =>
      deactivationWouldOrphanActiveHazards({
        floodingId: flooding.id,
        isDeactivating,
        allHazards: hazards,
      }),
    [flooding.id, isDeactivating, hazards],
  );

  if (!showOrphanWarning) return null;

  return (
    <Alert severity="warning">
      <Typography>
        {t(
          'createEditFlooding.inputs.status.deactivationBlockedByChildHazards',
        )}
      </Typography>
    </Alert>
  );
};
